import React from "react";
import FlexSection from "../../../Section/FlexSection";
import Logo from "./components/Logo";
import NavButton from "./components/NavButton";
import NavbarEnd from "./components/NavbarEnd/NavbarEnd";
import NavbarItems from "./components/NavbarItems/NavbarItem";

export default function NavbarLg({
  customer,
  logout,
  navbarToggle,
  showNavDd,
  drawerOpen,
  toggleDrawer,
}) {
  return (
    <div>
      {!drawerOpen && (
        <section className="mx-auto md:py-3 px-5">
          <FlexSection extraClass={"justify-between items-center"}>
            <Logo />
            <NavButton toggleDrawer={toggleDrawer} />
            <NavbarItems customer={customer} />
            <NavbarEnd
              customer={customer}
              logout={logout}
              navbarToggle={navbarToggle}
              showNavDd={showNavDd}
            />
          </FlexSection>
        </section>
      )}
    </div>
  );
}
